import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Box, Grid, Card, Typography, ButtonGroup, Button, Slider, FormControlLabel, Switch, Pagination, IconButton, CardHeader, CardContent, FormControl, InputLabel, Select, MenuItem, List, ListItem, ListItemButton, ListItemText, Link, TextareaAutosize, Skeleton } from '@mui/material';
import ApiService from '../../utils/ApiService';
import { useSelector, useDispatch } from 'react-redux';
import SharedDialog from '../../features/dialogBox/dialogBox';
import CreatePostDialog from '../../component/dialogBox/CreatePostDialog';
import { ArrowForward, AutoAwesome, ChevronRight, ForkLeft, KeyboardArrowLeft } from '@mui/icons-material';
import { openSnackbar } from '../../features/snackbar/snackbarSlice';
import { GenaiContext } from '../../context/GenaiContext';
import TextField from '@mui/material/TextField';
import GenratedImageComponent from '../GenerativeAiComponent/GenratedImageComponent';
import ToneOfVoice from '../GenerativeAiComponent/ToneOfVoice';
import CardContentWithUtility from '../card/CardContentWithUtility';
import PurposeComponent from '../GenerativeAiComponent/PurposeComponent';
import GeneratedContentComponent from '../GenerativeAiComponent/GeneratedContentComponent';
import { identifierType } from '../TypeComponent';

const GenerativeAILayout = ({ setFlag, posts, announcements, isFeed, isHeader, isMore, isAwardHeader, isCelebration, isAwardTo, isBirthday, isJoiner, isPromotions, isAccolades, isWorkAniversary, isWeddings, isbirthAnnouncement, isStories, isCompany, isEvent, isLeaderSpeak, setPostsList, indivisualAPI, formTransform, reactPost, isOrganisationalFeed, isHiddenPost, isFavoriteFeeds }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.userListName)
  const [toneOfVoiceList, setToneOfVoiceList] = useState([])
  // const [selectedTone, setSelectedTone] = useState(1)
  const [wordLimit, setWordLimit] = useState()
  const [generatedData, setGeneratedData] = useState([])
  const [generatedContentData, setGeneratedContentData] = useState();
  // const [selectedPurpose, setSelectedPurpose] = useState("")
  const [generatePromptLoading, setGeneratePromptLoading] = useState(true);
  // const [selectedSkills, setSelectedSkills] = useState();
  const [hasTag, setHasTag] = useState(false)
  const [generatePromptContentLoading, setGeneratePromptContentLoading] = useState(false);

  // Button
  const [generateButtonValue, setGenerateButtonValue] = useState("Generate with AI");
  const [generatedPromptResponse, setGeneratedPromptResponse] = useState([]);
  const [currentSelectedFromGeneratedPromptResponse, setCurrentSelectedFromGeneratedPromptResponse] = useState();

  const [selectedPurpose, setSelectedPurpose] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedTone, setSelectedTone] = useState(1)
  const [hasTagStatus, setHasTagStatus] = useState(false);
  const [selectedWordLimit, setSelectedWordLimit] = useState();

  function purposeChangeHandler(item) {
    // console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : item : ", item);
    setSelectedPurpose(item);
    if (item)
      setGeneratePromptLoading(false)
    else
      setGeneratePromptLoading(true)

  }

  function userChangeHandler(item) {
    // console.debug("genAI : GenerativeAILayout : userChangeHandler : ComboBox : onChangeHandler : item : ", item);
    setSelectedUser(item);
  }

  function skillChangeHandler(item) {
    // console.debug("genAI : GenerativeAILayout : skillChangeHandler : ComboBox : onChangeHandler : item : ", item);
    setSelectedSkills(item);
  }

  function toneOfVoiceChangeHandler(item) {
    // console.debug("genAI : GenerativeAILayout : toneOfVoiceChangeHandler : ComboBox : onChangeHandler : item : ", item);
    setSelectedTone(item);
  }

  function hasTagStatusChangeHandler(item) {
    // console.debug("genAI : GenerativeAILayout : hasTagStatusChangeHandler : ComboBox : onChangeHandler : item : ", item);
    setHasTagStatus(item);
  }

  function wordLimitChangeHandler(item) {
    // console.debug("genAI : GenerativeAILayout : wordLimitChangeHandler : ComboBox : onChangeHandler : item : ", item);
    setSelectedWordLimit(item);
  }

  function selectedPromptChangeHandler(data) {
    // console.debug("genAI : GenerativeAILayout : selectedPromptChangeHandler : data : ", data);
    if (data) {
      setCurrentSelectedFromGeneratedPromptResponse(data);
    }
  }



  // Button



  const genaiWithPurposeType = useSelector((state) => state?.genaiPostType?.genaiWithPostType)
  // const [generatePromptLoading, setGeneratePromptLoading] = useState(true);


  useEffect(function () {
    ApiService.get('toneOfVoice').then(response => {
      setToneOfVoiceList(response.data.data)
    }).catch((error) => {
      console.error(error)
    })

    ApiService.get('wordLimit').then(response => {
      setWordLimit(response.data.data)
    }).catch((error) => {
      console.error(error)
    })
    // ApiService.get('genaiPromptCategory').then(response => {
    //   console.debug("GenAi : genaiPromptCategory : ", response.data.data);
    //   setLoadingPurposeList(false)
    //   setPurposeList(response.data.data)

    // }).catch((error) => {
    //   setLoadingPurposeList(false)
    //   dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));
    //   console.error(error)
    // })

  }, []);

  function genratePromptButtonStatus() {
    return generatePromptLoading;
  }

  function onGenerateContentWithAI(e) {
    // console.debug("onGenerateContentWithAI : selectedUser", selectedUser);
    // console.debug("onGenerateContentWithAI : selectedPurpose?.identifier", selectedPurpose?.identifier);
    let params = {
      skills: []
    };
    // console.debug("selectedSkills", selectedPurpose)
    if (selectedPurpose && selectedPurpose?.id) {
      params.genAIpromptCategoryId = selectedPurpose.id
      if (selectedPurpose?.identifier == identifierType().dailyPost) {
        params.userName = user?.userName + " " + user?.middleName + " " + user?.lastName
      } else if (selectedPurpose?.identifier == identifierType().promotions) {
        params.designation = selectedUser?.designation?.designation
      } else if (selectedPurpose?.identifier == identifierType().workAniversary) {
        params.joiningDate = selectedUser?.joiningDate
        if (selectedUser && selectedUser?.userName) {
          params.userName = selectedUser.userName
        }
      } else {
        if (selectedUser && selectedUser?.userName) {
          params.userName = selectedUser.userName
        }
      }
    }
    if (selectedTone) {
      params.genAItoneOfVoiceId = selectedTone?.id
      // params.genAItoneOfVoiceId = 3;
    }
    if (selectedWordLimit) {
      params.wordLimit = selectedWordLimit
    }

    if (hasTag) {
      params.hasTag = 1
    } else {
      params.hasTag = 0
    }
    if (selectedSkills && selectedPurpose?.identifier == identifierType().dailyPost) {
      selectedSkills.forEach((skill, index) => {
        params.skills[index] = skill?.skill;
      });
    } else {
      setSelectedSkills([])
    }

    if (e.target.name == 'generatePrompt') {
      params.promtGenerate = 1;
      setGeneratePromptLoading(true);
    } else {
      if (currentSelectedFromGeneratedPromptResponse) {
        params.promptCategoryData = currentSelectedFromGeneratedPromptResponse
      }
      setGeneratePromptContentLoading(true)
    }

    ApiService.get('genaiResponse', params).then(response => {
      setSelectedSkills([])
      if (e.target.name == 'generatePrompt') {
        if (response?.data?.data?.prompts) {
          setGeneratedPromptResponse(response.data.data.prompts);
          setGeneratePromptLoading(false);
          console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : prompts : ", response?.data?.data?.prompts);
          console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : inputPromptMessage : ", response?.data?.data?.inputPromptMessage);
          console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : originalResponse : ", response?.data?.data?.originalResponse);
        } else {
          console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : prompts : ", response?.data?.data?.prompts);
          console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : inputPromptMessage : ", response?.data?.data?.inputPromptMessage);
          console.debug("genAI : GenerativeAILayout : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : originalResponse : ", response?.data?.data?.originalResponse);

        }

      }
      if (e.target.name == 'generateContent') {
        // setGeneratedPromptResponse(response.data.data);
        // generatePost.push(response.data.data.prompt)
        setGeneratedData([response.data.data.prompt, ...generatedData]);
        setGeneratedContentData(response.data.data);
        setGeneratePromptContentLoading(false);
        setGenerateButtonValue("Re-Generate");
      }
      // generatePost.push(response.data.data.prompt)

      // setGeneratedData([response.data.data.prompt, ...generatedData])
      // setGeneratePromptContentLoading(false)
      // if (response.data.data) {
      //   setGenerateButtonValue("Re-Generate")
      // }
    }).catch((error) => {
      setSelectedSkills([])

      setGeneratePromptContentLoading(false)
      dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));

      // setLoadingPurposeList(false)
      console.error(error)
    })
    // setGeneratedData(promptList && promptList[currentPage - 1]?.promptData)
  }



  const genaiContextValue = {
    // setSelectedSkills,      // UserSkills list 
    // selectedEmployee, setSelectedEmployee,      // Set Selected Employee from dropdown
    // setGeneratePromptLoading
  }



  // const openDialogPublish = (id, data) => {
  //   // dispatch(openDialog(id));
  //   // dispatch(setData({ postBody: data }));
  //   // // console.log(openDialog(id))
  // }

  // const expandFunction = () =>  {
  // console.log('a1')
  // }

  const [expanded, setExpanded] = useState(false);
  const expandFunction = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  return (
    <GenaiContext.Provider value={genaiContextValue}>
      <Box >
        <Grid container spacing={2}>
        {!expanded && (
            <Grid className="grid1" item md={8} sx={{}}>
              <Card sx={{ mb: 2, p: 2, overflow: 'auto', height: 'calc(100vh - 64px - 37px - 36px)' }}>
                {/* <Box sx={{ display: 'flex', alignItems: 'center', }}> */}
                <PurposeComponent
                  purposeChangeHandler={purposeChangeHandler}
                  userChangeHandler={userChangeHandler}
                  skillChangeHandler={skillChangeHandler}
                />
                <GenratedImageComponent />
                <ToneOfVoice
                  toneOfVoiceChangeHandler={toneOfVoiceChangeHandler}
                  hasTagStatusChangeHandler={hasTagStatusChangeHandler}
                  wordLimitChangeHandler={wordLimitChangeHandler}
                />

                <Box mt='1rem'>
                  <Button name="generatePrompt" size='small' variant='contained'
                    // disabled={genratePromptButtonStatus()}
                    startIcon={<AutoAwesome />}
                    onClick={onGenerateContentWithAI}>
                    Generate Prompt
                  </Button>
                </Box>

                <Box mt='1rem'>
                  <CardContentWithUtility
                    initialContent={generatedPromptResponse}
                    setCurrentSelectedFromGeneratedPromptResponse={setCurrentSelectedFromGeneratedPromptResponse}
                    onGenerateContentWithAI={onGenerateContentWithAI}
                    generatePromptContentLoading={generatePromptContentLoading}
                    generateButtonValue={generateButtonValue}
                    selectedPromptChangeHandler={selectedPromptChangeHandler}
                  />
                </Box>
                {/* </Box> */}
              </Card>
            </Grid>
          )}


          <Grid item className='height-2 grid2' md={expanded ? 12 : 4} >
            <Grid container spacing={2}>
              <Grid item xs={12}>

                <GeneratedContentComponent
                  generatedData={generatedData}
                  generatedContentData={generatedContentData}
                  generatePromptContentLoading={generatePromptContentLoading}
                  handleToggle={expandFunction}
                  expanded={expanded}
                  setExpanded={setExpanded}
                />


              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <SharedDialog id="createPostWithAI">
          <CreatePostDialog id="createPostWithAI" mode={'edit'} genai={true} />
        </SharedDialog>
      </Box>
    </GenaiContext.Provider>
  );
};

export default GenerativeAILayout;